"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var border = function (color) { return "border: 1px solid " + color + ";"; };
exports.default = (function (_a) {
    var active = _a.active, messageType = _a.messageType;
    return function (_a) {
        var theme = _a.theme;
        return (messageType ? border(messageType === 'error' ? theme.palette.inputBorder[2] : theme.palette.inputBorder[1])
            : border(active ? theme.palette.inputBorderActive[0] : theme.palette.inputBorder[0]));
    };
});
